import axios from 'axios';
import Auth from '../auth/Auth';
import AppConfig from './ApiConfig';
import { ApiConfigCompany } from '../models/ApiConfigCompany';

let webClient = axios.create();
const UNAUTHORIZED = 401;

axios.interceptors.response.use(
    response => response,
    error => {
        const { status } = error.response;
        
        if (status === UNAUTHORIZED) {
            Auth.triggerUnathorizedRequest();
        }
        return Promise.reject(error);
    }
);

export class WebClient {
    getErrorMessage(errorResponse): string {
        const errorsObj = errorResponse?.data?.errors;

        if (!errorsObj) {
            return errorResponse?.data?.title || "An unknown error occurred.";
        }

        return Object.values(errorsObj)
            .flat()
            .join(" ");
    }

    handleError(error: any): Promise<any> {
        const response = error.response;

        if (response.status === UNAUTHORIZED) {
            Auth.triggerUnathorizedRequest();
        }

        return Promise.reject(`${response.status}: ${this.getErrorMessage(response)}`);
    }

    get(url: string, authToken: string = ""): Promise<any> {
        return webClient.get(this.getFullUrl(url), {
            headers: this.getAuthHeader(authToken)
        })
            .catch((error) => {
                return this.handleError(error);
            });
    }

    post(url: string, data: any, authToken: string = ""): Promise<any> {
        return webClient.post(this.getFullUrl(url), data, {
            headers: this.getAuthHeader(authToken)
        })
            .catch((error) => {
                return this.handleError(error);
            });
    }

    formPost(url: string, data: any, authToken: string = ""): Promise<any> {
        var headerInfo = this.getAuthHeader(authToken);
        headerInfo["Content-Type"] = "multipart/form-data";

        return webClient.post(
            this.getFullUrl(url), data, {
            headers: headerInfo
        })
            .catch((error) => {
                return this.handleError(error);
            });
    }

    put(url: string, data: any, authToken: string = ""): Promise<any> {
        return webClient.put(this.getFullUrl(url), data, {
            headers: this.getAuthHeader(authToken)
        })
            .catch((error) => {
                return this.handleError(error);
            });
    }

    delete(url: string, authToken: string = ""): Promise<any> {
        return webClient.delete(this.getFullUrl(url), {
            headers: this.getAuthHeader(authToken)
        })
            .catch((error) => {
                return this.handleError(error);
            });
    }

    getFullUrl(path: string) {
        var c: ApiConfigCompany = AppConfig.getSelectedCompany();
        return c.adminApiUrl + path;
    }

    getAuthHeader(authToken: string): any {
        if (authToken) {
            return {
                'Authorization': `Basic ${authToken}`
            };
        } else {
            return {};
        }
    }
}
